<template>
  <component
    :is="layoutComponent"
    v-bind="layoutProps">
    <template slot="field">

      <div v-if="isCustomCurrencySelected">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ selectedCurrency.symbol }}</span>
          </div>
          <input
            type="number"
            :id="field.attribute + '_converted'"
            :min="inputMin"
            :max="inputMax"
            :step="inputStep"
            v-model.number="priceValueInSelectedCurrency"
            class="form-control"
            :class="errorClasses"
            :placeholder="inputPlaceholder"
            :readonly="isReadonly"
            :disabled="isDisabled"
            v-bind="field.attrs"
            @input="updateBaseCurrency"
          />
          <div class="input-group-append">
            <span class="input-group-text">{{ baseCurrency.symbol }}{{ fieldValue }}</span>
          </div>
        </div>
      </div>


      <div v-else>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">{{ baseCurrency.symbol }}</span>
          </div>
          <input
            type="number"
            :id="field.attribute"
            :min="inputMin"
            :max="inputMax"
            :step="inputStep"
            v-model.number="fieldValue"
            class="form-control"
            :class="errorClasses"
            :placeholder="inputPlaceholder"
            :readonly="isReadonly"
            :disabled="isDisabled"
            v-bind="field.attrs"/>
        </div>
      </div>

    </template>
  </component>
</template>

<script>
import {FieldMixin} from '../mixins';

export default {
  name: 'FormPriceInSelectedCurrencyField',

  mixins: [FieldMixin],
  mounted() {
    this.updateSelectedCurrency()
  },
  data() {
    return {
      baseCurrency: this.$settings.base_currency,
      priceValueInSelectedCurrency: null,
    }
  },
  props: {
    placeholder: {},
    step: {},
    min: {},
    max: {},
  },

  computed: {
    isCustomCurrencySelected() {
      return this.baseCurrency.code !== this.selectedCurrency.code
    },

    selectedCurrency() {
      return this.$root.$account.currency
    },

    /**
     * Get the input placeholder.
     */
    inputPlaceholder() {
      return this.placeholder || this.field.placeholder
    },

    /**
     * Get the input step amount.
     */
    inputStep() {
      return this.step || this.field.step
    },

    /**
     * Get the input minimum amount.
     */
    inputMin() {
      return this.min || this.field.min
    },

    /**
     * Get the input maximum amount.
     */
    inputMax() {
      return this.max || this.field.max
    },
  },
  methods: {
    updateBaseCurrency() {
      if (this.priceValueInSelectedCurrency === '') {
        this.fieldValue = null;
      } else {
        this.fieldValue = (this.priceValueInSelectedCurrency / this.selectedCurrency.rate).toFixed(2);
      }
    },
    updateSelectedCurrency() {
      if (this.fieldValue !== null) {
        this.priceValueInSelectedCurrency = (this.fieldValue * this.selectedCurrency.rate).toFixed(2);
      }
    }
  },
  watch: {
    selectedCurrency() {
      this.updateSelectedCurrency()
    },
  },
}
</script>
